import React, { useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Utensils, Clock, CalendarDays, MapPin, X } from "lucide-react";
const menuHighlights = [{
  title: "Ausiliari Tessili",
  description: "Soluzioni chimiche avanzate per il Settore Tessile.\nFilatura, tintura e finissaggio di tutte le fibre.\xA0",
  price: "B2B",
  url: "https://www.bozzetto-group.com/it/",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/ausiliari_tessili_chimica.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/ausiliari_tessili_chimica.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/ausiliari_tessili_chimica.png-wvc-sizes",
    alt: "Ausiliari Tessili"
  },
  badge: "Core Business"
}, {
  title: "Materie Prime",
  description: "Fornitura di materie prime chimiche per settori industriali. Detergenza, Tessile Concia, Edilizia.",
  price: "B2B",
  url: "Richiedi Informazioni",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/materie_prime_industriali.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/materie_prime_industriali.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/materie_prime_industriali.png-wvc-sizes",
    alt: "Materie Prime"
  },
  badge: "Disponibilità Immediata"
}, {
  title: "Strumenti e Consumabili di Laboratorio",
  description: "Strumenti per il laboratorio e consumabili per il controllo qualità e la ricerca nel settore chimico-tessile.",
  price: "B2B",
  url: "https://example.com",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/strumenti_laboratorio_chimico.png",
    srcset: "/img/strumenti_laboratorio_chimica.png-wvc-srcset",
    sizes: "/img/strumenti_laboratorio_chimica.png-wvc-sizes",
    alt: "Strumenti e Consumabili"
  },
  badge: "Precisione"
}, {
  title: "Macchinari",
  description: "Macchinari avanzati per la produzione e il laboratorio tessile.\nMacchine per tintura, asciugamento, impianti di dosaggio prodotti liquidi e in polvere.\n\n",
  price: "B2B",
  url: "mailto:centrochimica@centrochimica.it",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/macchinari.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/macchinari.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/macchinari.png-wvc-sizes",
    alt: "Macchinari"
  },
  badge: "Disponibilità"
}];
const features = [{
  icon: Clock,
  title: "Orari di Apertura",
  details: "Lun-Ven: 08:30 - 18:00"
}, {
  icon: MapPin,
  title: "Sede Operativa",
  details: "Viale della Repubblica 298, Prato"
}, {
  icon: CalendarDays,
  title: "Consulenza Tecnica",
  details: "Disponibile su appuntamento"
}];
export default function EccellenzaChimicaNelDistrettoDiPrato() {
  const leFornitureRef = useRef<HTMLDivElement>(null);
  const [isAddressOpen, setIsAddressOpen] = useState(false);
  return <section data-section-id="261644" id="eccellenza-chimica-nel-distretto-di-prato" className="w-full bg-background text-foreground">
      {}
      <div className="relative w-full h-[70vh] min-h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/centro_chimica_hero_industrial.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/centro_chimica_hero_industrial.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/centro_chimica_hero_industrial.png-wvc-sizes" alt="Eccellenza Chimica Prato" className="w-full h-full object-cover grayscale" loading="lazy" />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative z-10 text-left px-4 max-w-4xl mx-auto flex flex-col items-start">
          <Badge variant="secondary" className="mb-6 bg-primary/20 text-primary hover:bg-primary/30 border-none backdrop-blur-sm rounded-md">
            Dal 1978 a Prato
          </Badge>
          <h1 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tighter">Centro Chimica S.r.l<span className="text-primary"><br /></span></h1>
          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl font-mono">
            Forniture industriali d'avanguardia radicate nel cuore del distretto tessile di Prato. Precisione tecnica e continuità operativa per la vostra impresa.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="mailto:centrochimica@centrochimica.it?subject=Richiesta%20Preventivo">
              <Button size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-md">
                Richiedi un Preventivo
              </Button>
            </Link>
            <Button size="lg" variant="outline" className="w-full sm:w-auto text-base h-12 px-8 bg-transparent text-white border-white hover:bg-white/10 hover:text-white rounded-md" onClick={() => leFornitureRef.current?.scrollIntoView({
            behavior: 'smooth'
          })}>
              Le Nostre Forniture
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="bg-secondary py-8 border-b border-border">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-border">
            {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center pt-6 md:pt-0 first:pt-0 px-4">
                <div className={`h-12 w-12 rounded-md bg-primary/10 flex items-center justify-center mb-4 text-primary ${i === 1 ? 'cursor-pointer hover:bg-primary/20 transition-colors' : ''}`} onClick={i === 1 ? () => setIsAddressOpen(true) : undefined}>
                  <feature.icon className="w-6 h-6" />
                </div>
                <h3 className="font-default font-semibold text-foreground mb-2">{feature.title}</h3>
                <p className="text-muted-foreground text-sm font-mono">
                  {i === 1 ? <Link to="https://www.google.com/maps/search/?api=1&query=Viale%20della%20Repubblica%20298%2C%20Prato" newTab className="hover:text-primary transition-colors">
                      {feature.details}
                    </Link> : feature.details}
                </p>
              </div>)}
          </div>
        </div>
      </div>

      {isAddressOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-background border border-border p-8 rounded-lg shadow-xl max-w-md w-full relative">
            <Button variant="ghost" size="icon" className="absolute top-2 right-2" onClick={() => setIsAddressOpen(false)}>
              <X className="w-4 h-4" />
            </Button>
            <div className="flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-md bg-primary/10 flex items-center justify-center mb-4 text-primary">
                <MapPin className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold mb-2">Sede Operativa</h3>
              <p className="text-muted-foreground font-mono mb-6">Viale della Repubblica 298, Prato</p>
              <Button onClick={() => setIsAddressOpen(false)} className="w-full">
                Chiudi
              </Button>
            </div>
          </div>
        </div>}

      {}
      <div id="le-nostre-forniture" ref={leFornitureRef} className="py-24 container mx-auto px-4">
        <div className="text-left max-w-3xl mb-16">
          <div className="flex items-center justify-start gap-3 mb-4">
            <Separator className="w-12 bg-primary" />
            <Utensils className="w-5 h-5 text-primary" />
            <Separator className="w-12 bg-primary" />
          </div>
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Le Nostre Forniture
          </h2>
          <p className="text-muted-foreground text-lg font-sans">
            Centro Chimica S.r.l. offre un catalogo completo di soluzioni per l'industria, garantendo standard qualitativi elevati e consulenza tecnica specializzata.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {menuHighlights.map((item, i) => <Card key={i} data-index={i} className="overflow-hidden border-border/50 shadow-sm hover:shadow-lg transition-all duration-300 group flex flex-col rounded-md">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={item.image.src} data-wvc-srcset={item.image.srcset} data-wvc-sizes={item.image.sizes} alt={item.image.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 grayscale hover:grayscale-0" loading="lazy" />
                <div className="absolute top-4 right-4">
                  
                </div>
              </div>
              <CardHeader className="pb-4 flex-none">
                <div className="flex justify-between items-start gap-4">
                  <CardTitle className="font-default text-xl leading-tight font-bold">
                    {item.title}
                  </CardTitle>
                  <span className="font-mono font-bold text-primary text-sm shrink-0">
                    {item.price}
                  </span>
                </div>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="text-base leading-relaxed font-sans">
                  {item.description}
                </CardDescription>
                <Link to={i === 2 ? "https://eu-it.ohaus.com/it-eu/" : item.url} newTab={i !== 1}>
                  <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive bg-primary text-primary-foreground shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 mt-4 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90" data-active-element={i === 1 || i === 3 ? "true" : undefined}>
                    {i === 0 ? "Bozzetto Group" : i === 1 ? "Richiedi Informazioni" : i === 2 ? "Ohaus" : "Richiedi Informazioni"}
                  </Button>
                </Link>
                {i === 2 && <Link to="https://mesdan.com/it/strumenti-di-laboratorio" newTab>
                    <Button size="lg" className="mt-4 w-full">
                      Mesdan Lab
                    </Button>
                  </Link>}
                {i === 0 && <Link to="https://www.asutex.com/" newTab>
                    <Button size="lg" className="mt-4 w-full">
                      Asutex
                    </Button>
                  </Link>}
                {i === 3 && <>
                    <Link to="https://colorservice.eu/" newTab>
                      <Button size="lg" className="mt-4 w-full">
                        ColorService
                      </Button>
                    </Link>
                    <Link to="https://www.gavazzilab.it/it" newTab>
                      <Button size="lg" className="mt-4 w-full">
                        Gavazzi Lab
                      </Button>
                    </Link>
                    <Link to="https://www.lorisbellini.com/" newTab>
                      <Button size="lg" className="mt-4 w-full">
                        Loris Bellini
                      </Button>
                    </Link>
                    <Link to="https://www.miele.it/it/p/" newTab>
                      <Button size="lg" className="mt-4 w-full">
                        Miele
                      </Button>
                    </Link>
                    <Link to="https://www.noseda1893.it/" newTab>
                      <Button size="lg" className="mt-4 w-full">
                        Noseda 1893
                      </Button>
                    </Link>
                    <Link to="https://www.rfsystems.it/it/" newTab>
                      <Button size="lg" className="mt-4 w-full">
                        RF System
                      </Button>
                    </Link>
                    <Link to="https://www.stalam.com/tecnico/" newTab>
                      <Button size="lg" className="mt-4 w-full">
                        Stalam
                      </Button>
                    </Link>
                  </>}
              </CardContent>
            </Card>)}
        </div>
        
        <div className="mt-16 text-left">
           
        </div>
      </div>

      {}
      <div className="relative py-24 bg-foreground text-background overflow-hidden">
        {}
        <div className="absolute inset-0 !opacity-[1] bg-primary-foreground" />
        
        <div className="container mx-auto px-4 relative z-10 text-left max-w-3xl">
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 tracking-tighter">
            Contatta il Nostro Ufficio Tecnico
          </h2>
          <p className="text-background/80 text-lg md:text-xl mb-10 font-sans">Dalla consulenza sui processi alla fornitura di macchinari e strumenti di laboratorio, il nostro team è a disposizione per supportarvi.</p>
          <div className="flex flex-col sm:flex-row justify-start gap-4">
            <Link to="mailto:centrochimica@centrochimica.it?subject=Contatta%20ns%20Ufficio%20tecnico">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto text-base h-14 px-8 font-semibold bg-primary text-primary-foreground rounded-md">
                Invia Richiesta
              </Button>
            </Link>
            
          </div>
        </div>
      </div>
    </section>;
}